@if (!isAuthRoute) {
  <header class="vbp-header">
    <div class="w-full pl-4 pr-2 flex justify-between items-center h-full">
      <a routerLink="/" class="flex items-center">
        <img
          [src]="headerLogoSrc()"
          alt="Vertical Bridge"
          class="w-[199px] h-auto"
        />
      </a>
      <div class="flex items-center gap-4">
        <app-theme-picker class="translate-x-[8px]" />

        @if (isAuthenticated) {
          <div
            (mouseenter)="showMenu = true"
            (mouseleave)="showMenu = false"
            class="vbp-profile-pill"
          >
            <svg class="vbp-profile-icon" viewBox="0 0 1792 1792" fill="currentColor" aria-hidden="true">
              <path transform="translate(0 1536) scale(1 -1)" d="M896 1536q182 0 348 -71t286 -191t191 -286t71 -348q0 -181 -70.5 -347t-190.5 -286t-286 -191.5t-349 -71.5t-349 71t-285.5 191.5t-190.5 286t-71 347.5t71 348t191 286t286 191t348 71zM1515 185q149 205 149 455q0 156 -61 298t-164 245t-245 164t-298 61t-298 -61t-245 -164t-164 -245t-61 -298q0 -250 149 -455q66 327 306 327q131 -128 313 -128t313 128q240 0 306 -327zM1280 832q0 159 -112.5 271.5t-271.5 112.5t-271.5 -112.5t-112.5 -271.5t112.5 -271.5t271.5 -112.5t271.5 112.5t112.5 271.5z" />
            </svg>
            <span>{{ userName }}</span>
            @if (showMenu) {
              <div class="menu">
                <div
                  class="links"
                  (click)="openEditAccount()"
                  (keydown.enter)="openEditAccount()"
                  tabindex="0"
                  role="button"
                >
                  My Account
                </div>
                <div
                  class="links"
                  (click)="logout()"
                  (keydown.enter)="logout()"
                  tabindex="0"
                  role="button"
                >
                  Logout
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </header>

  <app-edit-account-modal
    [isOpen]="isEditAccountOpen"
    [userEmail]="userEmail"
    [displayName]="userName"
    (closed)="isEditAccountOpen = false"
    (saved)="onAccountSaved($event)"
  />
}

<router-outlet />
